module.exports = "img/photo23.e56489.jpg";